import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import InputWrapper from "../../../citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../../../citizen/AVPForms/components/Button";
import { CustomAccordionSummary } from "../../../citizen/AVPForms/components/StyledComponent";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

import axios from "axios";
function EmployeeList({
  t,
  superUser,
  control,
  updatedAuthority,
  setValue,
  handleSubmit,
  onSubmit,
  watch,
  departmentList,
  getOfficesListForIndex,
  getOtherRoleName,
  trigger,
}) {
  const [loading, setLoading] = useState(true);
  const [employeeList, setEmployeeList] = useState([]);
  const user = Digit.UserService.getUser();

  const authToken = user?.access_token || null;
  const columns = [
    { id: "empId", label: "S.NO.", width: "17%" },
    { id: "name", label: "Name", width: "16%" },
    { id: "role", label: "Designation", width: "13%" },
    { id: "remark", label: "Mobile No", width: "13%" },
    { id: "upload", label: "Employee Id", width: "13%" },
  ];
  useEffect(() => {
    if (updatedAuthority) {
      setValue("selectedAuthorityDeactivate", updatedAuthority);
    }
  }, [updatedAuthority, setValue]);

  const getFilteredOffices = () => {
    const offices = getOfficesListForIndex();
    console.log("officesList", offices, updatedAuthority);

    return offices.map((item) => {
      console.log("itemValue", item.value !== updatedAuthority, item.value);

      return {
        ...item,
        disabled: item.value == updatedAuthority,
      };
    });
  };

  async function handleEmpSearch(authority) {
    if (!authority) {
      return;
    }
    setLoading(true);
    // let location = authority?.split(" ")[0];
    // if (location?.startsWith("Unit")) {
    //   location = authority?.split(" ")[0] + " " + authority?.split(" ")[1];
    // }
    const location = authority?.includes("Development Authority") ? authority.split("Development Authority")[0].trim() : authority;
    console.log("locationFromHandleEMpSearch", location);
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user?.info,
      },
    };
    try {
      const response = await axios.post(`${Urls.hrms.employeeSearch}?location1=${location}`, payload);
      setEmployeeList(response?.data?.user);
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error("Error fetching employees", error);
      setLoading(false);
      throw error;
    }
  }

  const getDesignation = (emp) => {
    if (emp?.designationName) {
      return emp.designationName;
    }

    const roles = emp?.roles;
    if (roles && roles?.length > 0) {
      const filteredRoles = roles.filter((item) => item?.code !== "EMPLOYEE" && item?.code !== "CITIZEN");
      if (filteredRoles.length > 0) {
        return filteredRoles.map((role) => role?.name || role?.code).join(", ");
      }
    }
    return "N/A";
  };

  return (
    <section className="groupContainer2">
      <form className="formContainer" onSubmit={handleSubmit(onSubmit)}>
        <Accordion defaultExpanded>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Search Employee")}</h2>
            </div>
          </CustomAccordionSummary>

          <AccordionDetails className="formInputContainer common-app-form">
            {/* FROM Section */}

            <Container fluid>
              <Row className="mb-3">
                <Col md={4}>
                  <InputWrapper
                    control={control}
                    label="Authority"
                    name={`selectedAuthorityDeactivate`}
                    type="selectInput"
                    data={getFilteredOffices()}
                    disabled={!superUser}
                  />
                </Col>
                <Col md={4}>
                  <div className="buttonWrapper emp-transfer-buttonwrapper" style={{ justifyContent: "center" }}>
                    <ButtonWrapper
                      variant="contained"
                      color="info"
                      size="medium"
                      label={
                        <React.Fragment>
                          Search{" "}
                          <SearchIcon
                            sx={{
                              color: "#fff",
                              height: "18px",
                              width: "18px",
                              marginTop: "0px",
                            }}
                          />
                        </React.Fragment>
                      }
                      type="button"
                      disabled={!watch("selectedAuthorityDeactivate")}
                      onClick={() => handleEmpSearch(watch("selectedAuthorityDeactivate"))}
                      sx={{
                        backgroundColor: "#1565C0",
                        marginRight: "4px",
                        marginTop: "px",
                        display: "flex",
                        justifyConent: "center",
                        alignItems: "center",
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Container>

            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      style={{
                        width: column.width,
                        fontWeight: "bold",
                        background: "#1f4a7c",
                        color: "#fff",
                        fontSize: "13px",
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {employeeList.length > 0 ? (
                  employeeList.map((emp, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ fontSize: "13px" }}>{index + 1}</TableCell>
                      <TableCell style={{ fontSize: "13px" }}>{emp.name || "-"}</TableCell>
                      <TableCell style={{ fontSize: "13px" }}>{getDesignation(emp)}</TableCell>
                      <TableCell style={{ fontSize: "13px" }}>{emp.mobileNumber || "-"}</TableCell>
                      <TableCell style={{ fontSize: "13px" }}>{emp.userName || "-"}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </form>
    </section>
  );
}

export default EmployeeList;
